import React, { useEffect, useState } from 'react';

function ContactWidget({ hideSidebar }) {
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState('qq');

  useEffect(() => {
    const handler = () => setShowModal(true);
    window.addEventListener('openContactModal', handler);
    return () => window.removeEventListener('openContactModal', handler);
  }, []);

  const copyToClipboard = () => {
    navigator.clipboard.writeText('2222692').then(() => {
      alert('QQ号已复制！');
    }, () => {
      alert('复制失败，请手动复制');
    });
  };

  return (
    <>
      <div className="contact-widget" style={{
        position: 'fixed',
        right: '0',
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 100,
        display: hideSidebar ? 'none' : 'flex',
        flexDirection: 'column',
        gap: '10px'
      }}>
        <div onClick={() => { setModalType('qq'); setShowModal(true); }} className="contact-btn contact-btn-qq" style={{
          width: '60px',
          height: '60px',
          background: 'rgba(0,0,0,0.6)',
          borderRadius: '8px 0 0 8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          backdropFilter: 'blur(5px)',
          border: '1px solid rgba(255,255,255,0.1)',
          borderRight: 'none',
          transition: 'all 0.3s'
        }}
        onMouseOver={(e) => e.currentTarget.style.background = '#efa765'}
        onMouseOut={(e) => e.currentTarget.style.background = 'rgba(0,0,0,0.6)'}
        >
        <span style={{ fontSize: '24px' }}>
             <img src="/images/side_qq_icon.png" alt="san tiao" style={{ maxWidth: '100%', height: 'auto' }} />
        </span>
        </div>
        <div onClick={() => { setModalType('santiao'); setShowModal(true); }} className="contact-btn contact-btn-santiao" style={{
          width: '60px',
          height: '60px',
          background: 'rgba(0,0,0,0.6)',
          borderRadius: '8px 0 0 8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          backdropFilter: 'blur(5px)',
          border: '1px solid rgba(255,255,255,0.1)',
          borderRight: 'none',
          transition: 'all 0.3s'
        }}
        onMouseOver={(e) => e.currentTarget.style.background = '#d32f2f'}
        onMouseOut={(e) => e.currentTarget.style.background = 'rgba(0,0,0,0.6)'}
        >
        <span style={{ fontSize: '24px' }}>   
            <img src="/images/santiao_icon.png" alt="san tiao" style={{ maxWidth: '100%', height: 'auto' }} />
          </span>
        </div>
      </div>

      {showModal && (
        <div className="contact-modal-backdrop" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(0,0,0,0.7)',
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        onClick={() => setShowModal(false)}
        >
          <div className="contact-modal" style={{
            width: '320px',
            maxWidth: '90vw',
            background: '#fff',
            borderRadius: '16px',
            overflow: 'hidden',
            boxShadow: '0 10px 40px rgba(0,0,0,0.5)',
            position: 'relative'
          }}
          onClick={(e) => e.stopPropagation()}
          >
             <div style={{
               background: 'linear-gradient(to bottom, #333, #000)',
               padding: '16px',
               textAlign: 'center',
               color: '#fff',
               fontSize: '1.1rem',
               fontWeight: 'bold',
               position: 'relative'
             }}>
               {modalType === 'qq' ? '添加客服QQ下载' : '添加三条号下载'}
               <span onClick={() => setShowModal(false)} style={{
                 position: 'absolute',
                 right: '15px',
                 top: '50%',
                 transform: 'translateY(-50%)',
                 cursor: 'pointer',
                 fontSize: '1.5rem',
                 lineHeight: 1
               }}>&times;</span>
             </div>
             
             <div style={{ padding: '30px', textAlign: 'center', background: '#fff' }}>
               {modalType === 'qq' ? (
                 <>
                   <img src="/images/wechat_qr.png" alt="WeChat QR" style={{ width: '180px', height: '180px', marginBottom: '10px' }} />
                   <p style={{ color: '#333', fontSize: '1.2rem', margin: '10px 0', fontWeight: 'bold' }}>2222692</p>
                   <button onClick={copyToClipboard} style={{
                     background: 'linear-gradient(90deg, #b8864b, #d4af37)',
                     color: '#fff',
                     border: 'none',
                     padding: '12px 40px',
                     borderRadius: '6px',
                     fontSize: '1rem',
                     fontWeight: 'bold',
                     cursor: 'pointer',
                     width: '100%',
                     marginTop: '10px',
                     boxShadow: '0 4px 10px rgba(184, 134, 75, 0.4)'
                   }}>
                     复制QQ号
                   </button>
                 </>
                          ) : (
                                  <>
                                      <span style={{ color: '#d32f2f', fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '20px', display: 'block' }}>三条客服号：king33</span>    
                                <img src="/images/san_tiao.jpeg" alt="san tiao" style={{ maxWidth: '100%', height: 'auto' }} />
                            </>
               )}
             </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ContactWidget;
